import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useState
} from "react";

// consts
import {
  conversationTypes,
  filetrTypes,
} from "../../../../constant/app/inbox/Inbox";

// hooks
import { useSearch } from "hooks/useSearch";
import { useSelect } from "hooks/useSelect";
import useToggle from "hooks/useToggle";

// antd
import {
  useAspDispatch,
  useAspSelector,
} from "../../../../test/jest-redux-hooks";
import {
  conversationsView,
  deleteNote,
  inboxAttachments,
  inboxCustomerJourney,
  inboxFavourite,
  inboxList,
  inboxNotes,
  inboxResolved,
  inboxResolvedReopen,
  inboxTeamMembers,
  markAsUnread,
  teamMembersAssign,
  markMessagesAsRead,
} from "../../api/Api";

// providers
import { NoteProvider } from "../../providers/NoteContext";

// components
import { Tooltip } from "antd";
import NoData from "components/commonComponents/Nodata/index";
import CrmTagIcon from "../../../../assets/customSVG/crmTagIcon";
import AllConversations from "../../../../assets/customSVG/inbox/AllConversations";
import InboxStickyNote from "../../../../assets/customSVG/inbox/InboxStickyNote";
import PaperClipIcon from "../../../../assets/customSVG/inbox/PaperClipIcon";
import { ICONS } from "../../../../assets/icons";
import SearchBar from "../../../../components/commonComponents/searchBar/index";
import { getRandomColorsBassedOnLetters } from "../../../../helper/colors";
import { setExpand, updateToggleToast } from "../../../../reduxToolkit/appSlice";
import { crmSingleContactView } from "../../../crm/api/Api";
import {
  INITIAL_STATE,
  singleContactReducer,
} from "../../../crm/reducers/singleContactReducer";
import ConversationsTypes from "../conversation/ConversationsType";
import ConversationContainer from "./ConversationContainer";
import CustomerPhoneNumber from "./CustomerPhoneNumber";
import CustomSelect from "./CustomSelect";
import RightSideBar from "./RightSideBar";

// notifications
import NotificationContext from "../../../../providers/NotificationProvider";

const cleanParams = (value) =>
  value?.replaceAll("-", "")?.replaceAll(" ", "")?.trim();

let phoneNumberCount = 0;
let limit = 10;
let page = 1;
let converstationLimit = 20;
let converstationPage = 1;

export default function Conversation({
  primaryLoading,
  loading,
  setLoading,
  selectedPhoneNumber,
  activeTabName,
  activeTabItem,
  setNumberListLoading,
  selectedConversationType,
  setSelectedConversationType,
  teamMembersClick,
  campaigns,
  campaignExecutions,
  campaignExecutionsLoading,
  showCampaignExecutions,
}) {
  const { currentBrand, currentUser, expand, toggleToast } = useAspSelector(
    (state) => state?.app
  );

  const { searchKey, setSearchKey, onChange } = useSearch("");
  const dispatch = useAspDispatch();

  const [conversationList, setConversationList] = useState([]);
  const [selectedFilterType, setSelectedFilterType] = useSelect(null);
  const [selectedFilterTypeValue, setSelectedFilterTypeValue] = useSelect(null);
  const [selectedPerson, setSelectedPerson] = useSelect(null);

  // conversations
  const [alert, setAlert] = useToggle(false);
  const [isConversationLoading, setIsConversationLoading] = useToggle(false);
  const [conversation, setConversation] = useState([]);
  const [lastSync, setLastSync] = useState(null); // unix-ms
  const [favorite, setFavorite] = useState(null);
  const [resolved, setResolved] = useState(null);
  const [lastReplied, setLastReplied] = useState(null);
  const [watsappCount, setWatsappCount] = useState(null);
  const [contactlistLoading, setContactListLoading] = useToggle(false);
  const [selectedData, setSelectedData] = useState(null);
  // pagination
  const [conversationLimit, setConversationLimit] = useState(20);
  const [conversationPage, setConversationPage] = useState(1);
  const [isFetchingPage, setIsFetchingPage] = useState(false);

  const [newMessageIds, setNewMessageIds] = useState([]);
  const [totalMessageCount, setTotalMessageCount] = useState(null);

  // Right navigation with CRM DATAS
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);
  const [isSideNavOpenIcon1, setIsSideNavOpenIcon1] = useState(false);
  const [isSideNavOpenIcon2, setIsSideNavOpenIcon2] = useState(false);
  const [isSideNavOpenIcon3, setIsSideNavOpenIcon3] = useState(false);
  const [isSideNavOpenIcon4, setIsSideNavOpenIcon4] = useState(false);
  const [contactPopover, setContactPopover] = useState(false);
  const [journeyLists, setJourneyLists] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [notes, setNotes] = useState([]);
  // const [noteDelete, setNoteDelete] = useState('all');
  const [attachmentFilter, setAttachmentFilter] = useState("all");
  const [profession, setProfession] = useState([]);
  const [data, viewDispatch] = useReducer(singleContactReducer, INITIAL_STATE);

  // ASSIGN
  const [assignOpen, setAssignOpen] = useState(false);
  const [assignGetData, setAssignGetData] = useState([]);
  const [membersTrue, setMembersTrue] = useState(false);

  // Template
  const [openTemplateList, setOpenTemplateList] = useToggle(false);

  // Campaign Executions
  const [selectedCampaignExecution, setSelectedCampaignExecution] = useState(
    {}
  );

  // Note
  const [chatToggle, setChatToggle] = useState(true);

  // notifications
  const notification = useContext(NotificationContext);

  const [conversationUnreadData, setConversationUnreadData] = useState({
    open_unread_count: 0,
    closed_unread_count: 0,
  });

  const crmListView = (brandId, id) => {
    if (brandId && id) {
      crmSingleContactView(
        currentBrand?.brand_id,
        selectedPerson?.contact_person_id
      ).then((res) => {
        if (res && res?.data) {
          const contactData = res?.data?.overview?.[0];
          viewDispatch({ type: "update_data", data: contactData });
        }
      });
    }
  };

  useEffect(() => {
    setSelectedFilterType(filetrTypes);
    setSelectedFilterTypeValue(null);
  }, [activeTabName]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (alert) setAlert(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [alert]);

  const conversationType = selectedConversationType
    ?.filter((item) => item?.isSelected === true)
    ?.map((item) => item.msg?.toLowerCase());

  const countryCode = activeTabItem?.country_code?.replace("+", "") || "";
  const phoneNumberSpace =
    activeTabItem?.send_from_phone_number?.replace(" ", "") || "";
  const filterValues = selectedFilterTypeValue
    ?.filter((item) => item?.type !== "favorited")
    .map((item) => item?.type);

  const filterValuesFavorite = selectedFilterTypeValue
    ?.filter((item) => item?.type === "favorited")
    .map((item) => item?.type);

  // INBOX - LIST
  const fetchInboxList = async (load, brandId, limit, page) => {
    let inbox_filter;
    if (
      !["All Conversations", "Favorited", "Unassigned"].includes(activeTabName)
    ) {
      if (selectedFilterTypeValue && selectedFilterTypeValue?.length > 0) {
        inbox_filter = selectedFilterTypeValue
          .filter(
            (item) =>
              item.isSelected &&
              (item.type === "unread" || item.type === "resolved")
          )
          .map((item) => item.type)
          .join(",");
      }

      if (["Unread", "Resolved"].includes(activeTabName)) {
        inbox_filter = activeTabName?.toLowerCase();
      }
    }

    const payLoad = {
      brandId: brandId,
      limit: limit,
      page: page,
      conversation: conversationType,
      search: searchKey,
      businessPhoneNumber: countryCode + phoneNumberSpace,
      inbox_filter: inbox_filter,
      favourite:
        (filterValuesFavorite?.length > 0 || activeTabName === "Favorited") &&
        true,
      unassigned: activeTabName === "Unassigned" && true,
      // tag_id: activeTabItem.id && activeTabItem.id,
      ...(activeTabItem?.tag && { tag_id: activeTabItem.id }),
      user_id:
        (activeTabName === "Your Inbox" && currentUser?.id) ||
        (teamMembersClick && activeTabItem?.id),
      contact_conversation_id: activeTabName === "Unread" && selectedPerson?.id,
      campaign_id: showCampaignExecutions && activeTabItem?.id,
      include_broadcasts:
        showCampaignExecutions && selectedCampaignExecution?.include_broadcasts,
      include_sequences:
        showCampaignExecutions && selectedCampaignExecution?.include_sequences,
    };

    // if (load) setLoading(true);
    try {
      const res = await inboxList(payLoad);
      setNumberListLoading(false);
      // page === 1
      //   ? setConversationList(res?.data?.phone_number_list)
      //   : setConversationList([
      //       ...conversationList,
      //       ...res?.data?.phone_number_list,
      //     ]);
      setConversationList(res?.data?.phone_number_list);

      phoneNumberCount = res?.data?.phone_numbers_count;
      setConversationUnreadData({
        open_unread_count:
          res?.data?.conversation_unread_counts?.open_unread_count,
        closed_unread_count:
          res?.data?.conversation_unread_counts?.closed_unread_count,
      });
    } catch (e) {
      console.warn(e);
    } finally {
      if (load) setLoading(false);
    }
  };

  const shouldResetPerson = useMemo(() => {
    return activeTabName === "Unread";
  }, [activeTabName]);

  useEffect(() => {
    if (shouldResetPerson) {
      setSelectedPerson(null);
    }
  }, [shouldResetPerson]);

  useEffect(() => {
    if (
      (currentBrand?.brand_id && selectedPhoneNumber) ||
      (currentBrand?.brand_id && teamMembersClick)
    ) {
      fetchInboxList(
        true,
        currentBrand?.brand_id,
        converstationLimit,
        converstationPage,
        conversationType,
        activeTabName,
        selectedFilterType,
        searchKey
      );
    }
  }, [
    selectedPhoneNumber,
    searchKey,
    activeTabName,
    // favorite,
    selectedFilterType,
    selectedConversationType,
    teamMembersClick,
  ]);

  const loadNextPage = async () => {
    converstationLimit += 20;
    if (currentBrand?.brand_id && selectedPhoneNumber) {
      setContactListLoading(true);
      try {
        await fetchInboxList(
          true,
          currentBrand?.brand_id,
          converstationLimit,
          converstationPage,
          conversationType,
          activeTabName,
          searchKey
        );
      } finally {
        setContactListLoading(false);
      }
    }
  };

  // ASSIGN_CLICK

  useEffect(() => {
    if (selectedPerson) {
      const payLoad = {
        brand_id: currentBrand?.brand_id,
        contact_conversation_id: selectedPerson?.id,
      };

      inboxTeamMembers(
        payLoad?.brand_id,
        payLoad?.contact_conversation_id
      ).then((res) => {
        if (res?.status === 200) {
          setAssignGetData(res?.data?.users);
        }
      });
    }
  }, [selectedPerson, membersTrue]);

  const onAssignClick = (item) => {
    const payLoad = {
      brand_id: currentBrand?.brand_id,
      contact_conversation_id: item?.id,
    };

    inboxTeamMembers(payLoad?.brand_id, payLoad?.contact_conversation_id).then(
      (res) => {
        if (res?.status === 200) {
          setAssignGetData(res?.data?.users);
        }
      }
    );
  };

  const handleAssign = (item) => {
    const payLoad = {
      brand_id: currentBrand?.brand_id,
      user_id: item?.id,
      contact_conversation_id: selectedPerson?.id,
      assigned: !item?.assigned,
    };

    teamMembersAssign(payLoad).then((res) => {
      if (res?.status === 200) {
        const payLoad = {
          brand_id: currentBrand?.brand_id,
          contact_conversation_id: selectedPerson?.id,
        };

        inboxTeamMembers(
          payLoad?.brand_id,
          payLoad?.contact_conversation_id
        ).then((res) => {
          if (res?.status === 200) {
            setAssignGetData(res?.data?.users);
          }
        });
      }
    });
  };

  // FAVORITE _ CLICK

  const onFavoriteClick = (item) => {
    setFavorite(favorite === item.id ? null : item.id);

    const payLoad = {
      brand_id: currentBrand?.brand_id,
      contact_id: item?.contact_id,
      user_id: currentUser?.id,
      is_favourite: favorite !== null ? false : true,
    };

    inboxFavourite(payLoad).then((res) => {
      if (res?.status === 200) {
        fetchInboxList(
          true,
          currentBrand?.brand_id,
          converstationLimit,
          converstationPage,
          conversationType,
          activeTabName,
          selectedFilterType,
          searchKey
        );
        setSelectedPerson((prev) => ({
          ...prev,
          is_favourite: res?.data?.favourite?.is_favourite,
        }));
        // setSelectedPerson({
        //   ...selectedPerson,
        //   is_favourite: res?.data?.favourite?.is_favourite,
        // });
      }
    });
  };

  //  RESOLVED_CLICKs

  const lastWindow =
    conversation[conversation?.length - 1]?.message?.type === "window";

  const onResolvedClick = useCallback(
    (item) => {
      const payLoad = {
        brand_id: currentBrand?.brand_id,
        contact_conversation_id: item?.id,
        user_id: currentUser?.id,
      };

      const isReopen = item?.resolve_status === true;
      const apiCall = isReopen ? inboxResolved : inboxResolvedReopen;

      apiCall(payLoad)
        .then((res) => {
          if (res?.status === 200) {
            // Use functional update for resolvedState
            setResolved((prevResolved) =>
              prevResolved === item.id ? null : item.id
            );

            // Fetch inbox list with latest parameters
            fetchInboxList(
              true,
              currentBrand?.brand_id,
              converstationLimit,
              converstationPage,
              conversationType,
              activeTabName,
              selectedFilterType,
              searchKey
            );

            // Update selected person's resolve status
            const updatedResolveStatus = res?.data?.ccr
              ? res?.data?.ccr?.status
              : res?.data?.resolved;

            setSelectedPerson((prev) => ({
              ...prev,
              resolve_status: updatedResolveStatus,
            }));

            // Handle template list based on conditions
            if (isReopen && res?.data?.ccr) {
              setOpenTemplateList(!!lastWindow);
            }
          }
        })
        .catch((error) => {
          console.error("API call error:", error);
        });
    },
    [
      currentBrand,
      currentUser,
      converstationLimit,
      converstationPage,
      conversationType,
      activeTabName,
      selectedFilterType,
      searchKey,
      lastWindow,
    ]
  );

  const onMarkUnread = useCallback((item) => {
    const payLoad = {
      brand_id: currentBrand?.brand_id,
      contact_conversation_id: item?.id,
    };

    markAsUnread(payLoad)
      .then((res) => {
        if (res?.status === 200) {
          dispatch(
            updateToggleToast([
              ...toggleToast,
              {
                id: toggleToast?.length + 1,
                content: "Marked as unread successfully",
                status: "Success",
                duration: "",
              },
            ])
          );
        }
      })
      .catch((error) => {
        console.error("API call error:", error);
      });
  }, []);

  useEffect(() => {
    let intervalId;

    if (currentBrand?.brand_id && selectedPhoneNumber) {
      setLoading(false);
      intervalId = setInterval(() => {
        fetchInboxList(
          true,
          currentBrand?.brand_id,
          converstationLimit,
          converstationPage,
          conversationType,
          activeTabName,
          selectedFilterType,
          searchKey
        );
      }, 2000);
    }

    return () => {
      // Clear the interval immediately when dependencies change
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [
    currentBrand?.brand_id,
    selectedPhoneNumber,
    converstationLimit,
    converstationPage,
    conversationType,
    activeTabName,
    selectedFilterType,
    loading,
    searchKey,
  ]);

// 1) Merge only the returned delta into your existing array
const mergeDelta = useCallback(({ new_messages, status_updates }) => {
  setConversation(prev => {
    if (!prev.length) return [];

    // Get the contact_conversation_id from the first message in the conversation
    const currentConversationId = prev[0]?.contact_conversation_id;

    // Build a Set of existing IDs
    const existingIds = new Set(prev.map(m => m.id));

    // Filter new messages to only include those that:
    // 1. Don't already exist in the conversation
    // 2. Have the same contact_conversation_id as the current conversation
    const uniqueNew = new_messages
      ? new_messages.filter(m => 
          !existingIds.has(m.id) && 
          m.contact_conversation_id === currentConversationId
        )
      : [];

    // Merge in only the unique and matching messages
    const merged = [...prev, ...uniqueNew];

    // Now apply status updates on the merged array
    if (status_updates?.length) {
      return merged.map(msg => {
        const upd = status_updates.find(u => u.id === msg.id);
        return upd ? { ...msg, status: upd.status } : msg;
      });
    }

    return merged;
  });
}, []);

  // fetch the conversation b/w selected customer number
  const getConversations = useCallback(
    async (
      type,
      brandId,
      limit,
      page,
      contact_conversation_id,
      delta = false
    ) => {
      setIsConversationLoading(type === "select" && !delta);

      const payload = {
        brandId,
        limit,
        page,
        contact_conversation_id,
        ...(delta && { since: lastSync }),
      };

      try {
        const res = await conversationsView(payload);
        setIsFetchingPage(false);
        const data = res.data;

        // always advance your clock
        setLastSync(data.server_time || Date.now());
        // Mark messages as read if this is a select operation (not a scroll or delta update)
        if (type === "select") {
          const payLoad = {
            brand_id: brandId,
            contact_conversation_id: contact_conversation_id,
          };
      
          // Fire and forget - don't await the response
          markMessagesAsRead(payLoad).catch(error => {
            console.error("Failed to mark messages as read:", error);
          });
        }

        if (type === "scroll") {
          // --- pagination: prepend older messages ---
          const older = data.wapp_conversation.reverse();
          setConversation(prev => {
            const existingIds = new Set(prev.map(m => m.id));
            // only keep those we don't already have
            const uniqueOlder = older.filter(m => !existingIds.has(m.id));
            return [...uniqueOlder, ...prev];
          });
          if (data.wapp_conversation_count) {
            setTotalMessageCount(data.wapp_conversation_count);
          }
          return;
        }

        if (data.new_messages) {
          // --- delta updates only ---
          mergeDelta(data);
          setLastReplied(data.last_replied_at);
          const newMessages = data.new_messages;
          // const customerMsgs = newMessages.filter(m => m.is_customer_msg);

          // check if the content need to scroll down
          setNewMessageIds((prev) => {
            const newIds = [...prev, ...newMessages.map((m) => m.id)];
            return [...new Set(newIds)];
          });
        } else {
          // --- full history on "select" ---
          const full = data.wapp_conversation.reverse();
          setLastReplied(data.last_replied_at);
          setConversation(full);
          setTotalMessageCount(data.wapp_conversation_count);
          return data.wapp_conversation_count;
        }
      } catch (err) {
        console.warn(err);
      } finally {
        setIsConversationLoading(false);
      }
    },
    [lastSync, mergeDelta, conversationPage]
  );

  // scrolling use effect
  useEffect(() => {
    if (conversationPage > 1 && selectedPerson?.id) {
      getConversations(
        "scroll",
        currentBrand.brand_id,
        conversationLimit,
        conversationPage,
        selectedPerson.id
      ).finally(() => {
        // setIsFetchingPage(false);   // 👈 clear the “in flight” flag
      });
    }
  }, [
    conversationPage,
    selectedPerson?.id,
    conversationLimit,
    currentBrand.brand_id,
  ]);

  const onConversationTypeChange = async (values) => {
    const updatedOptions = conversationTypes?.map((o) => {
      if (o?.id === values?.id) return { ...o, isSelected: true };
      return { ...o, isSelected: false };
    });

    setNumberListLoading(true);

    setSelectedConversationType(updatedOptions);
    setConversationList([]);
    phoneNumberCount = 0;
    setConversationUnreadData({
      open_unread_count: 0,
      closed_unread_count: 0,
    });
    converstationPage = 1;
    converstationLimit = 20;
    setSelectedPerson(null);
  };

  const onFilterChange = (values) => {
    const filters = selectedFilterType?.map((item) => {
      if (item?.id === values?.id)
        return { ...item, isSelected: !item?.isSelected };
      return item;
    });

    const filterValues = filters?.filter((item) => item?.isSelected && item);

    setSelectedFilterType(filters);
    setSelectedFilterTypeValue(filterValues);
  };

  const clearType = () => {
    const res = selectedFilterType?.map((t) => {
      return { ...t, isSelected: false };
    });

    setSelectedFilterType(res);
    setSelectedFilterTypeValue(null);
  };

  const onConversationStarChange = (value) => {};

  const onCloseConversation = (value) => {};

  const messageData = conversationList?.find(
    (item) => item?.id === selectedPerson?.id
  )?.message;

  let c = "";

  switch (messageData?.type) {
    case "text":
      c = messageData.text?.body;
      break;

    case "template":
      const bodyTemplate = messageData.template?.find((t) => t.type === "BODY");
      c = bodyTemplate?.text;
      break;

    case "button":
      c = messageData.button?.text;
      break;

    case "document":
      c = messageData.document?.link;
      break;

    case "image":
      c = messageData.image?.link;
      break;

    case "video":
      c = messageData.video?.link;
      break;

    case "audio":
      c = messageData.audio?.link;
      break;

    default:
      c = "";
      break;
  }

  const cc_staus = conversationList?.find(
    (item) => item?.id === selectedPerson?.id && item
  )?.message_status;

  const cc_updated_at = conversationList?.find(
    (item) => item?.id === selectedPerson?.id && item
  )?.updated_at;

  // To update the conversation for message status update, new messages
  useEffect(() => {
    if (c) {
      onSelectPerson(selectedPerson, false);
    }
  }, [selectedPerson, c, cc_staus, cc_updated_at]);

  const onSelectPerson = useCallback(
    async (person, refresh = true) => {
      setChatToggle(true);
      if (refresh) {
        setConversation([]);
        setConversationPage(1);
        setNewMessageIds([]);
        setIsSideNavOpen(false);
        setNotes([]);
        setIsSideNavOpenIcon2(false);
        setIsSideNavOpenIcon1(false);
        setIsSideNavOpenIcon3(false);
        setIsSideNavOpenIcon4(false);
      }
      setLastSync(null);
      // setNoteContent([]);
      setSelectedData(null);

      if (refresh) {
        setSelectedPerson(person);
        await getConversations(
          "select",
          currentBrand?.brand_id,
          conversationLimit,
          1,
          person.id
        );
      } else {
        await getConversations(
          "select",
          currentBrand.brand_id,
          conversationLimit,
          1,
          person.id,
          lastSync,
          true
        );
      }
    },
    [currentBrand, getConversations]
  );

  // CRM

  useEffect(() => {
    if (selectedPerson) {
      crmListView(currentBrand?.brand_id, selectedPerson?.contact_person_id);
    }

    // if (isSideNavOpen) {
    //   professions();
    // }
  }, [selectedPerson, isSideNavOpen, currentBrand]);

  // const professions = () => {
  //   crmProfessions().then((res) => {
  //     if (res && res.data?.professions?.length > 0) {
  //       const updatedData = res?.data?.professions.map((p) => {
  //         return { ...p, label: p.name };
  //       });
  //       setProfession(updatedData);
  //     }
  //   });
  // };

  const customerJourney = () => {
    const payLoad = {
      brand_id: currentBrand?.brand_id,
      contact_conversation_id: selectedPerson?.id,
      page: page,
      limit: limit,
    };
    inboxCustomerJourney(payLoad).then((res) => {
      if (res && res?.data?.customer_journey?.length > 0) {
        setJourneyLists(res?.data?.customer_journey);
      }
    });
  };

  const getAttachments = async (attachment_type, skip = 0, limit = 100) => {
    const payLoad = {
      brand_id: currentBrand?.brand_id,
      contact_conversation_id: selectedPerson?.id,
      page: skip,
      limit: limit,
      attachment_type: attachment_type,
    };
    const res = await inboxAttachments(payLoad);
    if (res && res?.status === 200 && res?.data?.attachments) {
      setAttachments(res?.data?.attachments);
    }
  };

  const noteDelete = async (note, skip = 0, limit = 100) => {
    const payLoad = {
      brand_id: currentBrand?.brand_id,
      contact_conversation_id: selectedPerson?.id,
      note_id: note?.id,
      page: skip,
      limit: limit,
    };
    const res = await deleteNote(payLoad);

    if (res && res?.status === 200) {
      getNotes(currentBrand?.brand_id, selectedPerson?.id, limit, page);
    }
  };

  const getNotes = async (skip = 0, limit = 100) => {
    // need to remove the limit hardcore
    const payLoad = {
      brand_id: currentBrand?.brand_id,
      contact_conversation_id: selectedPerson?.id,
      page: 1,
      limit: 1000,
    };
    const res = await inboxNotes(payLoad);
    if (res && res?.data?.notes) {
      setNotes(res?.data?.notes);
    }
  };

  const handleToggleSideNav = (type) => {
    dispatch(setExpand(false));
    setIsSideNavOpen((prev) => {
      const newState = prev === type ? null : type;

      // Handle the icon state based on the toggled state and type
      if (type === "contact") {
        setIsSideNavOpenIcon1(newState === "contact");
        setIsSideNavOpenIcon2(false);
        setIsSideNavOpenIcon3(false);
        if (newState === "contact") {
          crmListView(
            currentBrand?.brand_id,
            selectedPerson?.contact_person_id
          );
        }
      } else if (type === "journey") {
        setIsSideNavOpenIcon2(newState === "journey");
        setIsSideNavOpenIcon1(false);
        setIsSideNavOpenIcon3(false);
        if (newState === "journey") {
          customerJourney(currentBrand?.brand_id, selectedPerson?.id);
        }
      } else if (type === "attachments") {
        setIsSideNavOpenIcon3(newState === "attachments");
        setIsSideNavOpenIcon1(false);
        setIsSideNavOpenIcon2(false);
        if (newState === "attachments") {
          getAttachments(attachmentFilter);
        }
      } else if (type === "notes") {
        setIsSideNavOpenIcon4(newState === "notes");
        setIsSideNavOpenIcon1(false);
        setIsSideNavOpenIcon2(false);
        setIsSideNavOpenIcon3(false);
        if (newState === "notes") {
          getNotes();
        }
      }

      return newState;
    });
  };

  const convo = conversationList?.filter(
    (item) => item?.id === selectedPerson?.id && item?.id
  );

  return (
    <div className="w-full h-full flex">
      <div className="m-0 h-full flex flex-1" style={{ width: "70vw" }}>
        <div
          className="border-r-[0.1vw] border-[var(--border-50)] flex-column gap-y-[0.1vw]"
          style={{ maxWidth: "18vw" }}
        >
          <div
            className="w-100 flex-column space-between pt-[18px] pb-2 px-[12px] p-relative overflow-hidden"
            style={{
              background: "white",
              boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.08)",
            }}
          >
            <div className="w-100 flex-row align-center space-between">
              <div className="w-full flex-row align-center">
                {activeTabItem?.icon1 && (
                  <img src={activeTabItem?.icon1} alt="icon" className="w-10" />
                )}
                {activeTabName === "All Conversations" && (
                  <AllConversations
                    color={
                      activeTabName ? "var(--textBlack)" : "var(--textBlack)"
                    }
                    fill={activeTabName ? "var(--textBlack)" : "none"}
                    stroke={activeTabName ? "white" : "var(--font-600)"}
                  />
                )}

                {activeTabName !== "All Conversations" &&
                  activeTabItem?.icon &&
                  activeTabName && (
                    <activeTabItem.icon
                      color={
                        activeTabName ? "var(--textBlack)" : "var(--textBlack)"
                      }
                      applyFill={activeTabName ?? "var(--a)"}
                      fill={activeTabName ? "var(--textBlack)" : "none"}
                      stroke={activeTabName ? "white" : "var(--font-600)"}
                      fillColor={activeTabName ? "none" : "none"}
                      lineColor={
                        activeTabName ? "var(--textBlack)" : "var(--font-600)"
                      }
                    />
                  )}
                {activeTabItem?.assignee !== undefined && (
                  <span
                    className="w-9 h-7 rounded-full border-[2px] border-white text-[0.65rem] font-[600]  flex items-center justify-center"
                    style={{
                      color: "white",
                      backgroundColor: getRandomColorsBassedOnLetters(
                        currentUser?.first_name?.slice(0, 1).toUpperCase(),
                        1.5
                      ).backgroundColor,
                    }}
                  >
                    {currentUser?.first_name?.slice(0, 1).toUpperCase()}
                  </span>
                )}

                {activeTabItem?.user_name !== undefined && (
                  <span
                    className="w-9 h-7 rounded-full border-[2px] border-white text-[0.65rem] font-[600]  flex items-center justify-center"
                    style={{
                      color: "white",
                      backgroundColor: getRandomColorsBassedOnLetters(
                        activeTabName?.slice(0, 1).toUpperCase(),
                        1.5
                      ).backgroundColor,
                    }}
                  >
                    {activeTabName?.slice(0, 1).toUpperCase()}
                  </span>
                )}
                {activeTabItem?.send_from_phone_number && (
                  <img src={ICONS?.whatsApp} alt="whatsApp" />
                )}

                {campaigns.length > 0 &&
                  activeTabItem?.name &&
                  (activeTabItem?.display_color ||
                    activeTabItem?.display_name) && (
                    <div className="text-lg">
                      {activeTabItem?.display_color && (
                        <div
                          className="size-4 rounded-[4px]"
                          style={{
                            background:
                              activeTabItem?.display_color ??
                              activeTabItem?.display_color,
                          }}
                        />
                      )}
                      {activeTabItem?.display_emoji && (
                        <span className="chart-headers">
                          {activeTabItem?.display_emoji}
                        </span>
                      )}
                    </div>
                  )}
                {activeTabItem?.tag && (
                  // <img src={ICONS?.addTags} alt="whatsApp" />
                  <CrmTagIcon />
                )}

                <div className="w-full pl-10 new-header text-[1vw]">
                  {activeTabName && (
                    <Tooltip title={activeTabName}>
                      <div className="truncate overflow-hidden whitespace-nowrap w-[78%]">
                        {activeTabName.charAt(0).toUpperCase() +
                          activeTabName.slice(1)}
                      </div>
                    </Tooltip>
                  )}
                </div>
              </div>
              {/* <span className="text-end w-100 relative hidden">hii</span> */}

              <div className="overflow-hidden right-3 p-absolute z-50">
                <SearchBar
                  searchKey={searchKey}
                  setSearchKey={setSearchKey}
                  onChange={(value) => onChange(value)}
                  search="inbox-search"
                  searchCancel="inboxSearchCancel"
                  expandable="true"
                  // className={`${expandable ? "w-[20vw]" : ""}`}
                />
              </div>
            </div>

            {searchKey && (
              <div className="flex align-center w-100 pt-10">
                <img
                  src={ICONS?.infoIconViolet}
                  alt="infoIconViolet"
                  className="w-[15px] h-[15px]"
                />
                <p className="text-[#6940F2] text-[0.75vw] font-[500] italic pl-1">
                  Skip spaces when searching for a number!
                </p>
              </div>
            )}

            {showCampaignExecutions && (
              <CustomSelect
                broadcasts={campaignExecutions
                  ?.filter((item) => item?.entry_type === "broadcast")
                  .map((item) => ({
                    id: item?.id,
                    broadcast_id: item?.broadcast_id,
                    name: item?.broadcast_name,
                    broadcast_status: item?.broadcast_status,
                  }))}
                sequences={campaignExecutions
                  ?.filter((item) => item?.entry_type === "sequence")
                  .map((item) => ({
                    id: item?.id,
                    campaign_sequence_id: item?.campaign_sequence_id,
                    name: item?.campaign_sequence_name,
                    campaign_sequence_status: item?.campaign_sequence_status,
                  }))}
                onSelectExecutionList={(...args) => {
                  setSelectedCampaignExecution(args[0]);
                }}
                loading={campaignExecutionsLoading}
              />
            )}
            <ConversationsTypes
              loading={primaryLoading ? true : loading}
              conversations={selectedConversationType}
              selectedConversationType={selectedConversationType}
              onConversationTypeChange={onConversationTypeChange}
              onFilterChange={onFilterChange}
              selectedFilterType={selectedFilterType}
              activeTabName={activeTabName}
              phoneNumberCount={phoneNumberCount}
              conversationUnreadData={conversationUnreadData}
              clearType={clearType}
            />
          </div>

          <CustomerPhoneNumber
            primaryLoading={primaryLoading}
            loading={primaryLoading ? true : loading}
            searchKey={searchKey}
            conversationList={conversationList}
            selectedPerson={selectedPerson}
            selectedConversationType={selectedConversationType}
            onSelectPerson={onSelectPerson}
            onFavoriteClick={onFavoriteClick}
            onResolvedClick={onResolvedClick}
            onConversationStarChange={onConversationStarChange}
            onCloseConversation={onCloseConversation}
            count={phoneNumberCount}
            loadNextPage={loadNextPage}
            favorite={favorite}
            resolved={resolved}
            contactlistLoading={contactlistLoading}
          />
        </div>
        {(selectedPerson &&
          conversationList?.length > 0 &&
          activeTabName !== "Unread" &&
          convo?.length > 0) ||
        (activeTabName === "Unread" && convo?.length > 0) ? (
          <NoteProvider>
            <div
              className="flex border-r-[0.1vw] border-[var(--border-50)] h-[100vh]"
              style={{ width: "38%", flex: 1 }}
            >
              <ConversationContainer
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                loading={isConversationLoading}
                selectedPhoneNumber={selectedPhoneNumber}
                selectedPerson={selectedPerson}
                selectedConversationType={selectedConversationType}
                conversation={conversation}
                getAttachments={getAttachments}
                attachmentFilter={attachmentFilter}
                onConversationStarChange={onConversationStarChange}
                onCloseConversation={onCloseConversation}
                alert={alert}
                getConversations={getConversations}
                onFavoriteClick={onFavoriteClick}
                onResolvedClick={onResolvedClick}
                setOpenTemplateList={setOpenTemplateList}
                openTemplateList={openTemplateList}
                lastWindow={lastWindow}
                conversationList={conversationList}
                favorite={favorite}
                resolved={resolved}
                lastReplied={lastReplied}
                c={c}
                setMembersTrue={setMembersTrue}
                membersTrue={membersTrue}
                onAssignClick={onAssignClick}
                assignOpen={assignOpen}
                setAssignOpen={setAssignOpen}
                assignGetData={assignGetData}
                setAssignGetData={setAssignGetData}
                handleAssign={handleAssign}
                isSideNavOpen={isSideNavOpen}
                activeTabItem={activeTabItem}
                onMarkUnread={onMarkUnread}
                setChatToggle={setChatToggle}
                chatToggle={chatToggle}
                setNotes={setNotes}
                getNotes={getNotes}
                isFetchingPage={isFetchingPage}
                setIsFetchingPage={setIsFetchingPage}
                setConversationPage={setConversationPage}
                totalMessageCount={totalMessageCount}
                newMessageIds={newMessageIds}
                setNewMessageIds={setNewMessageIds}
                contactPersondata={data}
              />
            </div>
            <div
              className={`h-full ${isSideNavOpen ? "" : " w-0"}`}
              style={{
                transition: "transform width 0.3s ease-in-out",
              }}
            >
              {isSideNavOpen && (
                <RightSideBar
                  selectedPerson={selectedPerson}
                  setIsSideNavOpen={setIsSideNavOpen}
                  contactPopover={contactPopover}
                  setContactPopover={setContactPopover}
                  data={data}
                  type={isSideNavOpen}
                  journeyLists={journeyLists}
                  attachments={attachments}
                  notes={notes}
                  noteDelete={noteDelete}
                  attachmentFilter={attachmentFilter}
                  getAttachments={getAttachments}
                  getNotes={getNotes}
                  setAttachmentFilter={setAttachmentFilter}
                  setIsSideNavOpenIcon3={setIsSideNavOpenIcon3}
                  setIsSideNavOpenIcon2={setIsSideNavOpenIcon2}
                  setIsSideNavOpenIcon1={setIsSideNavOpenIcon1}
                  setIsSideNavOpenIcon4={setIsSideNavOpenIcon4}
                  // profession={profession}
                  setChatToggle={setChatToggle}
                  chatToggle={chatToggle}
                />
              )}
            </div>
            <div
              className="flex flex-col gap-y-5 items-center my-[15px] mx-[10px] bg-white p-relative h-full pointer"
              // onClick={handleToggleSideNav}
              style={{ zIndex: 1000 }}
            >
              {!isSideNavOpenIcon1 ? (
                <img
                  src={ICONS?.contactRightInbox}
                  alt="contactRightInbox"
                  className="w-5"
                  onClick={() => handleToggleSideNav("contact")}
                  // style={{width: "20px"}}
                />
              ) : (
                <img
                  src={ICONS?.contactDetailsOpen}
                  alt="contactRightInbox"
                  className="w-7"
                  onClick={() => handleToggleSideNav("contact")}
                />
              )}
              {!isSideNavOpenIcon4 ? (
                <InboxStickyNote
                  className="bg-white  rounded-xl"
                  size={25}
                  onClick={() => handleToggleSideNav("notes")}
                />
              ) : (
                <InboxStickyNote
                  className="p-[5px]"
                  svgClassName="bg-gradient-to-r from-[#FBC640] to-[#FBC640] rounded-full text-white"
                  size={25}
                  onClick={() => handleToggleSideNav("notes")}
                />
              )}
              {!isSideNavOpenIcon3 ? (
                <PaperClipIcon
                  className="bg-white  rounded-xl"
                  size={29}
                  onClick={() => handleToggleSideNav("attachments")}
                />
              ) : (
                <PaperClipIcon
                  className="p-[2px]"
                  svgClassName="bg-gradient-to-r from-[#3B82F6] to-[#0551CC] rounded-full text-white"
                  size={26}
                  onClick={() => handleToggleSideNav("attachments")}
                />
              )}
              {!isSideNavOpenIcon2 ? (
                <img
                  src={ICONS?.customerJourneyInbox}
                  alt="customerJourneyInbox"
                  // className={`${
                  //   !isSideNavOpenIcon1 ? "pt-20 pl-[25px]" : "pt-20 pl-[40px]"
                  // }}`}
                  className="w-5"
                  onClick={() => handleToggleSideNav("journey")}
                />
              ) : (
                <img
                  src={ICONS?.customerJourneyOpen}
                  alt="contactRightInbox"
                  className="w-7"
                  onClick={() => handleToggleSideNav("journey")}
                />
              )}
            </div>
          </NoteProvider>
        ) : (
          <div className="w-full h-[75vh]">
            <NoData
              icon={ICONS?.inboxEmpty}
              title="This is a place to chat to your contacts in all of the connected channels"
              content={
                "Every time somebody sends you a message, it will appear here. You can change this and more in Live Chat Settings"
              }
              iconStyle={"w-[10vw]"}
              style={"max-w-[25vw]"}
              titleClassName="!font-largest"
            />
          </div>
        )}
      </div>
    </div>
  );
}
